/* Home page interactions (2026-10-10). Loaded deferred, only on the home page (layout/theme.liquid).
   - marks <html> with .ht-js so the reveal CSS can safely start hidden only once JS is running
   - scroll-reveal: sections + product cards fade/slide up as they enter the viewport (staggered)
   - toggles .ht-scrolled on <html> so the sticky header gets a shadow after scrolling
   Everything is skipped for prefers-reduced-motion users, and falls back to "just visible" if
   IntersectionObserver is unavailable. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header shadow on scroll — rAF-throttled passive listener */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('ht-scrolled', (window.scrollY || root.scrollTop) > 12);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* 2026-10-15: scroll-reveal (fade/slide-in of sections + product cards) switched off on purpose —
     too much motion on the home page, and content must be visible immediately. Only the header
     shadow above stays. To bring it back, delete the next line. */
  return;

  if (reduce || !('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;

    var targets = [];
    var sections = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    /* skip the first three (hero, trust strip, categories): they are above the fold / the LCP, they
       must never start hidden */
    sections.slice(3).forEach(function (sec) {
      sec.classList.add('ht-reveal');
      targets.push(sec);
    });

    /* stagger product cards inside each row (first 8 per row) as the row itself reveals */
    sections.slice(3).forEach(function (sec) {
      var cards = sec.querySelectorAll('product-card');
      Array.prototype.slice.call(cards, 0, 8).forEach(function (card, i) {
        card.classList.add('ht-reveal');
        card.style.setProperty('--ht-i', String(Math.min(i, 5)));
        targets.push(card);
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });

    /* safety net: if anything is still hidden a few seconds in (observer hiccup, print, etc.) show it */
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    }, 9000);

    root.classList.add('ht-js');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
